import { Tooltip } from "@material-ui/core";
import { get } from "lodash";
import React, { useEffect, useState, Fragment } from "react";
import { useRecoilValue } from "recoil";
import { CompanyDetails } from "../../recoil/LoggedInUserDetail/selector";

const TargetColor = ({ targetType, showName = true, showColor = false }) => {
  let companyDetail = useRecoilValue(CompanyDetails);

  const [target, setTarget] = useState();

  useEffect(() => {
    setTarget(
      (get(companyDetail, "referenceFeature.target", []) || []).length &&
      get(companyDetail, "referenceFeature.target", []).find(
        res => res.type === targetType
      )
    );
  }, [targetType]);

  return (
    <Fragment>
      {showName ? (
        <Tooltip
          className="cursor-default"
          title={get(target, "name", targetType)}>
          <span className="truncate-txt font-12">
            {target && showColor && (
              <span
                className="dot-indicator"
                style={{
                  background: get(target, "color", "")
                }}></span>
            )}
            {get(target, "name", targetType)}
          </span>
        </Tooltip>
      ) : null}
    </Fragment>
  );
};

export default TargetColor;
